import { Box, Checkbox, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const PersonalInfoBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  marginBottom: '24px',
}) as typeof Box;

export const DemographicInformationBlock = styled(PersonalInfoBlock)({}) as typeof Box;

export const PersonalInfoBlockTitle = styled(Typography)({
  color: palette.text.header,
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '130%',
}) as typeof Typography;

export const DemographicInformationBlockTitle = styled(PersonalInfoBlockTitle)(
  {}
) as typeof Typography;

export const PersonalInfoBlockDesc = styled(Typography)({
  color: palette.text.body,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '136%',
  whiteSpace: 'pre-line',
}) as typeof Typography;

export const DemographicInformationBlockDesc = styled(PersonalInfoBlockDesc)(
  {}
) as typeof Typography;

export const ProfileAvatarBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '24px',
}) as typeof Box;

export const ProfileAvatarBlockTitle = styled(Typography)({
  color: palette.text.header,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '128%',
}) as typeof Typography;

export const ProfileAvatarBlockAvatars = styled(Box)({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '8px',
}) as typeof Box;

export const AvatarItem = styled(Box)<{ selected: boolean }>(({ selected }) => {
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '56px',
    height: '56px',
    cursor: 'pointer',

    '&::before': {
      content: '""',
      display: selected ? 'block' : 'none',
      position: 'absolute',
      top: '-2px',
      left: '-2px',
      width: '56px',
      height: '56px',
      backgroundColor: 'transparent',
      border: '2px solid #85C553',
      borderRadius: '50%',
    },
  };
});

export const ProfileAvatarImg = styled('img')<{ selected: boolean }>(({ selected }) => {
  return {
    width: selected ? '48px' : '56px',
    height: selected ? '48px' : '56px',
  };
});

export const InputWithCheckboxWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '16px',
}) as typeof Box;

export const CheckboxWithText = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',

  ' > p': {
    color: palette.text.body,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '130%',
  },
}) as typeof Box;

export const CustomCheckbox = styled(Checkbox)({
  width: '22px',
  height: '22px',
  padding: '0',
  fontSize: '22px',

  '&.Mui-checked': {
    '&.Mui-disabled': {
      '.MuiSvgIcon-root': {
        fill: palette.unknown.checkbox_disabled_grey,
      },
    },
    '.MuiSvgIcon-root': {
      fill: palette.alerts.success,
    },
  },

  '&.Mui-disabled': {
    '.MuiSvgIcon-root': {
      fill: palette.unknown.checkbox_disabled_grey,
    },
  },

  '.MuiSvgIcon-root': {
    fill: palette.black,
    fontSize: '22px',

    '&:disabled': {
      fill: palette.unknown.checkbox_disabled_grey,
    },
  },
}) as typeof Checkbox;

export const Separator = styled(Box)({
  height: '1px',
  backgroundColor: palette.border.default,
  margin: '32px 0',
}) as typeof Box;
